import { render, staticRenderFns } from "./ChordProgressions.vue?vue&type=template&id=1d69c6d6"
import script from "./ChordProgressions.vue?vue&type=script&lang=js"
export * from "./ChordProgressions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports